import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
  Accordion,
  AccordionSummary,
  alpha,
  Box,
  Stack,
  styled,
  Typography,
} from '@mui/material';

export const StyledStack = styled(Stack)(({ theme }) => ({
  border: '2px solid',
  borderColor: theme.palette.divider,
  borderRadius: '16px',
  // Disable default Mui Accordion Wrapper rotation/transition
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'none',
    transition: 'none',
  },
  // width: 0 forces flex to ignore intrinsic content width, ensuring the 40% flex ratio is respected even with long, unbreakable text
  width: 0,
  overflow: 'hidden',
}));

export const StyledHeaderBox = styled(Box)(({ theme }) => ({
  padding: '16px',
  bgcolor: 'brand.whitesmoke',
  borderRadius: '16px 16px 0 0',
  borderBottom: '1px solid',
  borderBottomColor: theme.palette.divider,
  overflow: 'hidden',
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '&.MuiAccordion-root': {
    marginBottom: 0,
  },
  '&.Mui-expanded': {
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  flexDirection: 'row-reverse',
  height: '74px',
  gap: 2,
  borderBottom: '1px solid',
  borderBottomColor: theme.palette.divider,
  '&.Mui-expanded': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
}));

export const StyledIcon = styled(KeyboardArrowRightIcon)(() => ({
  transition: 'transform 0.3s ease',
  '.MuiAccordionSummary-expandIconWrapper.Mui-expanded &': {
    transform: 'rotate(90deg)',
  },
}));

export const StyledTypography = styled(Typography)(() => ({
  marginLeft: 1,
}));
